export default __webpack_public_path__ + "static/media/i-interior-1_connect.73cf000f.svg";